import {authHeaders, baseUrl, handleResponse} from "./apiUtils";

async function getLessonRegister(id) {
  const response = await fetch(`${baseUrl}lessonregister/${id}`, {
    headers: authHeaders(),
  });
  return handleResponse(response);
}

async function getLessonRegisters(fromDate, toDate) {
  const params = new URLSearchParams();

  if (fromDate) {
    params.append("fromDate", fromDate);
  }

  if (toDate) {
    params.append("toDate", toDate);
  }

  const query = params.toString() ? `?${params.toString()}` : "";
  const response = await fetch(`${baseUrl}lessonregister/${query}`, {
    headers: authHeaders(),
  });
  return handleResponse(response);
}

async function getClassLessonSummaryHistory(lessonId, { limit = 10, cursor } = {}) {
  const params = new URLSearchParams();
  params.append("limit", limit);
  if (cursor) params.append("cursor", cursor);
  const response = await fetch(
    `${baseUrl}lessonregister/${encodeURIComponent(lessonId)}/class-summary-history?${params.toString()}`,
    { headers: authHeaders() },
  );
  return handleResponse(response);
}

async function saveLessonRegister(lessonRegister) {
  const lessonRegisterId = lessonRegister.id && lessonRegister.id !== lessonRegister.lessonId
    ? lessonRegister.id
    : (lessonRegister.lessonId || lessonRegister.id || "");
  const persistedRecordId = lessonRegister.id || lessonRegisterId;

  const response = await fetch(`${baseUrl}lessonregister/${lessonRegisterId}`, {
    method: "PUT",
    headers: authHeaders({ "content-type": "application/json" }),
    body: JSON.stringify({
      ...lessonRegister,
      id: persistedRecordId,
    }),
  });
  return handleResponse(response);
}

async function deleteLessonRegister(id) {
  const response = await fetch(`${baseUrl}lessonregister/${id}`, {
    method: 'DELETE',
    headers: authHeaders({ 'content-type': 'application/json' }),
  });
  return handleResponse(response);
}

async function reportLessonAbsence({
  lessonId,
  studentId,
  reportedAt,
  note,
}) {
  const response = await fetch(`${baseUrl}lessonregister/${encodeURIComponent(lessonId)}/absence-report`, {
    method: "POST",
    headers: authHeaders({ "content-type": "application/json" }),
    body: JSON.stringify({ studentId, reportedAt, note }),
  });
  return handleResponse(response);
}

async function cancelWholeLesson({ lessonId, reason }) {
  const response = await fetch(`${baseUrl}lessonregister/${encodeURIComponent(lessonId)}/lesson-cancellation`, {
    method: "POST",
    headers: authHeaders({ "content-type": "application/json" }),
    body: JSON.stringify({ reason }),
  });
  return handleResponse(response);
}

async function undoWholeLessonCancellation({ lessonId }) {
  const response = await fetch(`${baseUrl}lessonregister/${encodeURIComponent(lessonId)}/lesson-cancellation/undo`, {
    method: "POST",
    headers: authHeaders({ "content-type": "application/json" }),
  });
  return handleResponse(response);
}

export default {
  getLessonRegister,
  getLessonRegisters,
  getClassLessonSummaryHistory,
  saveLessonRegister,
  deleteLessonRegister,
  reportLessonAbsence,
  cancelWholeLesson,
  undoWholeLessonCancellation,
};
